/**
 * 获取组件属性 [ 构建脚本用；Vue install用 ]
 * @param lib
 * @param slots
 * @returns {*}
 */

function ComExplorer(lib, slots) {
    this.UiLib = lib;
    this.slots = slots;
    return this;
}

ComExplorer.prototype.getProps = function (name) {
    const componentList = [];
    const UiLib = this.UiLib;
    const configs = this.slots;

    //获取所有组件的名称
    for(let key in UiLib){
        if(UiLib.hasOwnProperty(key) && UiLib[key].props){
            componentList.push(key)
        }
    }
    //如果name为空，则认为返回所有组件的配置
    if(!name){
        let props = {};
        componentList.forEach( c=> {
            props[c] = transformTypeAll(UiLib[c].props)
            props[c] = {
                name: c,
                props: transformTypeAll(UiLib[c].props),
                slots: configs[c] && configs[c].slots
            }
        });
        return props;
    }else if(componentList.indexOf(name)){
        //如果传入
        return {
            name,
            props: transformTypeAll(UiLib[name].props),
            slots: configs[name].slots
        }
    }else {
        // 传入name在mcUI中没有定义的情况
        console.warn(`[McUI]Component name '${name}' is not defined in McUI`);
        return false;
    }
};


function transformTypeAll(props) {
    let _props = {};
    for(let prop in props){
        if (props.hasOwnProperty(prop)){
            let thisProp = props[prop],
                {type, description, enumeration} = thisProp,
                _type;
            if(type && _.isArray(type)){
                _type = type.map(t => t.name).join(',');
            }else if(type){
                _type = type.name;
            }
            _props[prop] = {
                type: type,
                description, enumeration,
                default: thisProp['default'],
                _type: _type
            }
        }
    }
    return _props;
}

export default ComExplorer;



// WEBPACK FOOTER //
// ./src/lib/comExplorer.js